import { render, staticRenderFns } from "./LayoutNew.vue?vue&type=template&id=0de55d8a&scoped=true"
import script from "./LayoutNew.vue?vue&type=script&lang=js"
export * from "./LayoutNew.vue?vue&type=script&lang=js"
import style0 from "./LayoutNew.vue?vue&type=style&index=0&id=0de55d8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de55d8a",
  null
  
)

export default component.exports